(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("NDArray", [], factory);
	else if(typeof exports === 'object')
		exports["NDArray"] = factory();
	else
		root["NDArray"] = factory();
})(this, function() {
return 